import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon } from 'lucide-react';
import { PredictionCard } from './PredictionCard';
const mockPredictions = [{
  homeTeam: 'Barcelona',
  awayTeam: 'Ath. Bilbao',
  homeTeamLogo: 'https://r2.thesportsdb.com/images/media/team/badge/wq9sir1639406443.png/medium',
  awayTeamLogo: 'https://r2.thesportsdb.com/images/media/team/badge/68w7fe1639408210.png/medium',
  competition: 'La Liga',
  matchTime: '16:15',
  odds: '1.44',
  prediction: 'Barca Wins',
  formRating: 'Barca won their last 5 home matches',
  h2h: 'Barca won the last 6 home meetings',
  goalTrend: 'Barca average 3.2 goals per game'
}, {
  homeTeam: 'Barcelona',
  awayTeam: 'Real Madrid',
  homeTeamLogo: 'https://upload.wikimedia.org/wikipedia/en/4/47/FC_Barcelona_%28crest%29.svg',
  awayTeamLogo: 'https://upload.wikimedia.org/wikipedia/en/5/56/Real_Madrid_CF.svg',
  competition: 'La Liga',
  matchTime: '20:00',
  odds: '1.85',
  prediction: 'BTTS (Both Teams to Score)',
  formRating: 'Excellent attacking form both sides',
  h2h: 'Both scored in last 8 El Clásicos',
  goalTrend: 'Classic high-intensity matchup'
}, {
  homeTeam: 'Bayern Munich',
  awayTeam: 'Dortmund',
  homeTeamLogo: 'https://upload.wikimedia.org/wikipedia/commons/1/1b/FC_Bayern_M%C3%BCnchen_logo_%282017%29.svg',
  awayTeamLogo: 'https://upload.wikimedia.org/wikipedia/commons/6/67/Borussia_Dortmund_logo.svg',
  competition: 'Bundesliga',
  matchTime: '17:30',
  odds: '1.95',
  prediction: 'Home Win',
  formRating: 'Bayern unbeaten at home this season',
  h2h: 'Bayern won 6 of last 8 home fixtures',
  goalTrend: 'Strong home advantage'
}, {
  homeTeam: 'Liverpool',
  awayTeam: 'Chelsea',
  homeTeamLogo: 'https://upload.wikimedia.org/wikipedia/en/0/0c/Liverpool_FC.svg',
  awayTeamLogo: 'https://upload.wikimedia.org/wikipedia/en/c/cc/Chelsea_FC.svg',
  competition: 'Premier League',
  matchTime: '16:30',
  odds: '2.25',
  prediction: 'Over 1.5 Goals',
  formRating: 'Both teams averaging 2+ goals per game',
  h2h: 'Last 5 meetings all had 2+ goals',
  goalTrend: 'Consistent goal-scoring pattern'
}, {
  homeTeam: 'PSG',
  awayTeam: 'Marseille',
  homeTeamLogo: 'https://upload.wikimedia.org/wikipedia/en/a/a7/Paris_Saint-Germain_F.C..svg',
  awayTeamLogo: 'https://upload.wikimedia.org/wikipedia/commons/d/d8/Olympique_Marseille_logo.svg',
  competition: 'Ligue 1',
  matchTime: '21:00',
  odds: '1.75',
  prediction: 'Home Win & Over 2.5',
  formRating: 'PSG dominant at Parc des Princes',
  h2h: 'PSG won last 7 home matches vs Marseille',
  goalTrend: 'High-scoring Le Classique history'
}, {
  homeTeam: 'Inter Milan',
  awayTeam: 'AC Milan',
  homeTeamLogo: 'https://upload.wikimedia.org/wikipedia/commons/0/05/FC_Internazionale_Milano_2021.svg',
  awayTeamLogo: 'https://upload.wikimedia.org/wikipedia/commons/d/d0/Logo_of_AC_Milan.svg',
  competition: 'Serie A',
  matchTime: '19:45',
  odds: '2.05',
  prediction: 'BTTS',
  formRating: 'Derby della Madonnina always delivers',
  h2h: 'Both teams scored in 9 of last 10 derbies',
  goalTrend: 'Intense rivalry guarantees goals'
}];
export function PredictionsFeed() {
  return <section id="predictions" className="w-full py-16 px-4 bg-dark-card" data-id="element-210">
      <div className="container mx-auto max-w-7xl" data-id="element-211">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-212">
          <div className="inline-flex items-center gap-2 bg-neon-green/10 px-4 py-2 rounded-full mb-4" data-id="element-213">
            <TrendingUpIcon className="w-5 h-5 text-neon-green" data-id="element-214" />
            <span className="text-neon-green font-semibold text-sm" data-id="element-215">
              UPDATED DAILY
            </span>
          </div>

          <h2 className="text-2xl md:text-5xl font-black mb-4" data-id="element-216">
            <span className="text-gradient-green" data-id="element-217">
              Weekly Free Predictions
            </span>
          </h2>

          <p className="text-gray-400 text-base md:text-lg max-w-2xl mx-auto" data-id="element-218">
            Accurate, reliable, and carefully analyzed. Updated weekly.
          </p>
        </motion.div>

        {/* Predictions Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-219">
          {mockPredictions.map((prediction, index) => <PredictionCard key={index} {...prediction} index={index} data-id="element-220" />)}
        </div>

        {/* Bottom CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mt-12" data-id="element-221">
          <p className="text-gray-400 mb-4 text-sm md:text-base" data-id="element-222">
            Want more premium predictions with higher odds?
          </p>
          <a href="https://greenhsvip.site/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 md:px-8 py-3 md:py-4 bg-gradient-to-r from-neon-green to-emerald-600 rounded-xl font-bold text-base md:text-lg text-white hover:shadow-[0_0_30px_rgba(16,185,129,0.6)] transition-all hover:scale-105" data-id="element-223">
            Upgrade to VIP 🌟
          </a>
        </motion.div>
      </div>
    </section>;
}